import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: error?.message || 'Erro desconhecido' };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary capturou:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" data-testid="error-boundary-fallback">
          <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 max-w-md text-center space-y-4">
            <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
              <AlertTriangle size={32} className="text-amber-600" />
            </div>
            <h2 className="text-xl font-bold text-slate-800">Ops! Algo deu errado</h2>
            <p className="text-sm text-slate-500">
              Ocorreu um erro inesperado nesta tela. Seus dados estão seguros — recarregue a página para continuar.
            </p>
            <p className="text-xs text-slate-400 font-mono bg-slate-50 rounded p-2 break-words">
              {this.state.errorMsg}
            </p>
            <button
              className="w-full py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors flex items-center justify-center gap-2"
              onClick={() => window.location.reload()}
              data-testid="error-boundary-reload-btn"
            >
              <RefreshCw size={16} />
              Recarregar Página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
